import React from 'react';

export const withNoMargin = (WrappedComponent) => React.forwardRef((props, ref) => {
	return <WrappedComponent {...props} noMargin ref={ref} />;
});
